import { FC, useContext } from 'react'
import { Button, Icon } from '../Generic'
import { observer } from 'mobx-react'
import { StoreContext } from '@store/Root.store'
import { cx } from '@/utils/cx'

interface ScrollDocumentButtonProps {
  onClick?: () => void
  showScrollToBottomButton?: boolean
}

export const ScrollDocumentButton: FC<ScrollDocumentButtonProps> = observer(
  ({ onClick, showScrollToBottomButton }) => {
    const store = useContext(StoreContext)
    const { signDocumentPage: trans } = store.TranslationsState.translationsNew

    const scrollToBottom = () => {
      const element = document.querySelector('.onboarding-pdf-viewer-inner-wrap > div')

      if (element) {
        element.scrollTop = element.scrollHeight

        onClick && onClick()
      }
    }

    return (
      <div className={cx('scroll-document-button', showScrollToBottomButton ? '' : 'hidden')}>
        <Button onClick={scrollToBottom} tabIndex={0} dataTestid="test-scroll-bottom">
          <span className="generic__button-text">{trans.scrollButton}</span>
          <Icon color="currentColor" type="arrow-down" size="24px" />
        </Button>
      </div>
    )
  }
)
